// Global Instructions Rule Applied!

export const SET_FUND_TRANSACTIONS = 'fund_transactions/SET_FUND_TRANSACTIONS' as const
export const APPEND_FUND_TRANSACTIONS = 'fund_transactions/APPEND_FUND_TRANSACTIONS' as const
export const SET_ACTIVE_FILTERS = 'fund_transactions/SET_ACTIVE_FILTERS' as const
export const SET_ACTIVE_SORTING = 'fund_transactions/SET_ACTIVE_SORTING' as const
export const CLEAR_ACTIVE_FILTERS = 'fund_transactions/CLEAR_ACTIVE_FILTERS' as const
export const UPDATE_FUND_TRANSACTION_RECORD = 'fund_transactions/UPDATE_FUND_TRANSACTION_RECORD' as const
export const REMOVE_FUND_TRANSACTION = 'fund_transactions/REMOVE_FUND_TRANSACTION' as const
